import type {HelpFile} from '../../types/help'
import {WizardStepReviewSettingsTestIds} from '../../../testids/WizardStepReviewSettingsTestIds'

export const wizardStepReviewSettingsHelp: HelpFile = {
    docPage: '/docs/governance/certification-policies',
    texts: {
        [WizardStepReviewSettingsTestIds.selectReviewerType]:
            'Wer die Zertifizierungsaufgaben erhält — die Führungskraft, der Profileigentümer oder der Ressourceneigentümer.',
        [WizardStepReviewSettingsTestIds.optionReviewerManager]: null,
        [WizardStepReviewSettingsTestIds.optionReviewerProfileOwner]: null,
        [WizardStepReviewSettingsTestIds.optionReviewerResourceOwner]: null,
        [WizardStepReviewSettingsTestIds.checkboxOverrideReviewFrequency]:
            'Ausgeschaltet lassen, um die Prüfhäufigkeit jedes Zugriffsprofils zu verwenden.',
        [WizardStepReviewSettingsTestIds.inputReviewFrequencyDays]: null,
        [WizardStepReviewSettingsTestIds.inputGracePeriodDays]:
            'Tage nach dem Fälligkeitsdatum, bevor die Nichtreaktions-Aktion ausgelöst wird.',
        [WizardStepReviewSettingsTestIds.selectNonResponseAction]:
            'Was passiert, wenn ein Prüfer vor Ablauf der Nachfrist nicht reagiert.',
        [WizardStepReviewSettingsTestIds.optionNonResponseNoChange]: null,
        [WizardStepReviewSettingsTestIds.optionNonResponseAutoRevoke]: null,
        [WizardStepReviewSettingsTestIds.optionNonResponseEscalate]: null,
        [WizardStepReviewSettingsTestIds.checkboxAutoRevokeOnOverdue]: null,
        [WizardStepReviewSettingsTestIds.comboboxCampaignOwner]:
            'Identität, die als Eigentümer der angelegten Kampagne und als Ersatzprüfer verwendet wird.',
    },
}
